import { createSlice } from "@reduxjs/toolkit";
import { acknowledgeMerge, clearCreatedJob, exportToActTrak,  getPagedJobs, mergeJobs, resetJobListInvalidation, resetJobPage, resetJobSlice, searchJobs, deleteJob,renameJob } from "../actions/jobActions";
import { IJobState, JobListPage } from "../model/jobModel";

const defaultJobListPageState: JobListPage = {
    data: [],
    pageIndex: 0,
    pageSize: 50,
    totalCount: 0,
    totalPages:0,
    loading: false,
    error: "",
    hasNextPage: false,
    hasPreviousPage: false,
    mergeComplete: false,
    invalidateJobList: false
}

const initialState: IJobState = {
    searchingJobs: false,
    searchError: false,
    searchResults: [],
    creatingJob: false,
    creatingJobError: false,
    createdJob: null,
    jobsPage: {...defaultJobListPageState}
};

const jobSlice = createSlice({
    name: "job",
    initialState: initialState,
    reducers: {

    },
    extraReducers: ({ addCase }) => {
        addCase(searchJobs.pending, (state) => {
            state.searchingJobs = true;
        }); 

        addCase(searchJobs.rejected, (state) => {
            state.searchingJobs = false;
            state.searchError = true;
        });

        addCase(searchJobs.fulfilled, (state, action) => {
            state.searchingJobs = false;
            state.searchResults = action.payload.jobs;
        });

        addCase(clearCreatedJob, (state) => {
            state.createdJob = null;
            state.creatingJob = false;
            state.creatingJobError = false;
        });

        addCase(getPagedJobs.pending, (state) => {
            state.jobsPage.loading = true;
        });

        addCase(getPagedJobs.rejected, (state) => {
            state.jobsPage.loading = false;
            state.jobsPage.error = "There was an error retrieving jobs";
        });

        addCase(getPagedJobs.fulfilled, (state, action) => {
            state.jobsPage.loading = false;
            state.jobsPage = { 
                ...state.jobsPage,
                ...action.payload
            }
        });

        addCase(mergeJobs.pending, (state) => {
            state.jobsPage.loading = true;
        });

        addCase(mergeJobs.rejected, (state) => {
            state.jobsPage.loading = false;
            state.jobsPage.error = "There was an error merging jobs";
        });

        addCase(mergeJobs.fulfilled, (state, action) => {
            state.jobsPage.loading = false;
            state.jobsPage.data = [...state.jobsPage.data.filter(x => !action.meta.arg.MergeIds.includes(x.id)), action.payload.job]
            state.jobsPage.mergeComplete = true;
        });

        addCase(exportToActTrak.pending, (state) => {
            state.jobsPage.loading = true;
        });

        addCase(exportToActTrak.rejected, (state) => {
            state.jobsPage.loading = false;
            state.jobsPage.error = "There was an error exporting jobs";
        });

        addCase(exportToActTrak.fulfilled, (state, action) => {
            state.jobsPage.loading = false;  
            state.jobsPage.data = state.jobsPage.data.filter(x => !action.meta.arg.exportIds.includes(x.id));  
            state.jobsPage.invalidateJobList = true;        
        });

        addCase(deleteJob.pending, (state) => {
            state.jobsPage.loading = true;
        });

        addCase(deleteJob.rejected, (state) => {
            state.jobsPage.loading = false;
            state.jobsPage.error = "There was an error deleting the job";
        });

        addCase(deleteJob.fulfilled, (state, action) => {
            state.jobsPage.loading = false;
            // remove deleted job from current page data if present
            const deletedId = action.meta.arg;
            state.jobsPage.data = state.jobsPage.data.filter(x => x.id !== deletedId);            
        });
        
        addCase(renameJob.pending, (state) => {
            state.jobsPage.loading = true;
        });
        
        addCase(renameJob.rejected, (state) => {
            state.jobsPage.loading = false;
            state.jobsPage.error = "There was an error renaming the job";
        });
        
        addCase(renameJob.fulfilled, (state, action) => {
            state.jobsPage.loading = false;
            const { jobId, newName } = action.meta.arg;
            state.jobsPage.data = state.jobsPage.data.map(j => j.id === jobId ? { ...j, name: newName } : j);            
        });
        
        addCase(resetJobListInvalidation, (state) => {
            state.jobsPage.invalidateJobList = false;
        });

        addCase(acknowledgeMerge, (state) => {
            state.jobsPage.mergeComplete = false;
        });
        
        addCase(resetJobPage, (state) => {
            Object.assign(state.jobsPage, defaultJobListPageState);
        });

        addCase(resetJobSlice, (state) => {
            Object.assign(state, initialState);
        });
    }
});


export default jobSlice.reducer;